import { jsx as r, jsxs as k } from "react/jsx-runtime";
import { c as B } from "react/compiler-runtime";
import z from "@mui/icons-material/Close";
import { Alert as A } from "@mui/material";
import "react";
import { Button as G } from "../../atoms/Button/Button.js";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "@mui/icons-material";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "react-dom/server";
import "@mui/icons-material/Warning";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
import '../../../assets/map.css';import '../../../assets/FilterWrapper.css';/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Search";
import { Box as I } from "../../atoms/Box/Box.js";
import { Grid as E } from "../../atoms/Grid/Grid.js";
import "../../atoms/Typography/Typography.js";
import "@mui/material/styles";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../../organisms/DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "@mui/icons-material/ArrowForward";
import "../../organisms/RadarGraph/RadarGraph.js";
import "../../organisms/ReactMap/index.js";
import "@mui/material/Button";
import "../../organisms/ReactMap/GMapStatic.js";
import "../../organisms/ReactMap/hooks.js";
import "@mui/icons-material/Clear";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../../organisms/Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "../../organisms/ScoreGauge/ScoreGauge.js";
import "../../organisms/SunburstGraph/SunburstGraph.js";
import "@mui/icons-material/Menu";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Dialog";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "../../../fetch/fetchConfig.js";
import "immer";
import "../../atoms/FormControl/FormControl.js";
import "../../atoms/FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
import "../../../chunks/index.esm.js";
/* empty css                   */
import "../../atoms/Paper/Paper.js";
import "../../atoms/Radio/Radio.js";
import "../../atoms/RadioGroup/RadioGroup.js";
import { IconButton as S } from "../../atoms/IconButton/IconButton.js";
import "../../atoms/Menu/Menu.js";
import "../../atoms/MenuItem/MenuItem.js";
import "../../atoms/Table/Table.js";
import "../../atoms/TableBody/TableBody.js";
import "../../atoms/TableHead/TableHead.js";
import "../../atoms/TableRow/TableRow.js";
import "../../atoms/TableCell/TableCell.js";
import "../../atoms/ToggleButton/ToggleButton.js";
import "../../atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import "@mui/icons-material/ExpandMore";
import "../../atoms/Stepper/Stepper.js";
import "../../atoms/Step/Step.js";
import "../../atoms/StepLabel/StepLabel.js";
import "../../atoms/Link/Link.js";
import "../../atoms/LoadingButton/LoadingButton.js";
import "../../atoms/LinearProgress/LinearProgress.js";
import "../../atoms/Stack/Stack.js";
import "../../atoms/Card/Card.js";
import "../../atoms/CardActions/CardActions.js";
import "../../atoms/FormHelperText/FormHelperText.js";
import "../../atoms/AccordionDetails/AccordionDetails.js";
import "../../atoms/TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/material/Typography";
function j(w) {
  const t = /* @__PURE__ */ new Set();
  return w?.filter((o) => t.has(o?.message) ? !1 : (t.add(o?.message), !0));
}
function So(w) {
  const t = B(25), {
    errorsData: o,
    warningsData: f,
    closeAlert: i,
    closeAll: y
  } = w;
  let h;
  t[0] !== o ? (h = o === void 0 ? [] : o, t[0] = o, t[1] = h) : h = t[1];
  const v = h;
  let u;
  t[2] !== f ? (u = f === void 0 ? [] : f, t[2] = f, t[3] = u) : u = t[3];
  const D = u;
  let m;
  t[4] !== v ? (m = j(v), t[4] = v, t[5] = m) : m = t[5];
  let p;
  t[6] !== D ? (p = j(D), t[6] = D, t[7] = p) : p = t[7];
  let d;
  t[8] !== m || t[9] !== p ? (d = {
    errors: m,
    warnings: p
  }, t[8] = m, t[9] = p, t[10] = d) : d = t[10];
  const {
    errors: s,
    warnings: a
  } = d, b = (s?.length ?? 0) + (a?.length ?? 0);
  let g;
  t[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = {
    width: "100%",
    pb: 1,
    "& > * + *": {
      mt: 2
    }
  }, t[11] = g) : g = t[11];
  let e;
  t[12] !== i || t[13] !== s ? (e = s ? s.map((x, c) => /* @__PURE__ */ r(A, { severity: "error", action: /* @__PURE__ */ r(S, { "aria-label": "close", color: "inherit", size: "small", onClick: () => {
    i(c, "error");
  }, children: /* @__PURE__ */ r(z, { fontSize: "inherit" }) }), children: x.message }, c)) : null, t[12] = i, t[13] = s, t[14] = e) : e = t[14];
  let l;
  t[15] !== i || t[16] !== a ? (l = a ? a.map((x, c) => /* @__PURE__ */ r(A, { severity: "warning", action: /* @__PURE__ */ r(S, { "aria-label": "close", color: "inherit", size: "small", onClick: () => {
    i(c, "warning");
  }, children: /* @__PURE__ */ r(z, { fontSize: "inherit" }) }), children: x.message }, c)) : null, t[15] = i, t[16] = a, t[17] = l) : l = t[17];
  let n;
  t[18] !== y || t[19] !== b ? (n = b > 1 && /* @__PURE__ */ r(I, { display: "flex", justifyContent: "right", children: /* @__PURE__ */ r(G, { color: "primary", onClick: y, children: "Close All" }) }), t[18] = y, t[19] = b, t[20] = n) : n = t[20];
  let C;
  return t[21] !== l || t[22] !== n || t[23] !== e ? (C = /* @__PURE__ */ k(E, { sx: g, children: [
    e,
    l,
    n
  ] }), t[21] = l, t[22] = n, t[23] = e, t[24] = C) : C = t[24], C;
}
export {
  So as ErrorsComponent,
  So as default
};
